export type PaymentMethod = 'CASH' | 'CHECK' | 'BANK_TRANSFER' | 'CARD'
export type PaymentStatus = 'PENDING' | 'PAID' | 'REFUNDED' | 'FAILED'
export type OrderStatus = 'PENDING' | 'CONFIRMED' | 'READY_FOR_PICKUP' | 'COMPLETED' | 'CANCELLED'

export interface ProductVariant {
  id: number
  productId: number
  label: string
  stock: number
  isActive: boolean
  updatedAt?: string
}

export interface ShopProduct {
  id: number
  name: string
  description: string
  imageUrl: string
  memberPriceCents: number
  publicPriceCents: number
  isActive: boolean
  memberPriceEligible: boolean
  variants: ProductVariant[]
}

export interface QuoteItem {
  variantId: number
  productId: number
  productName: string
  variantLabel: string
  imageUrl: string
  quantity: number
  stock: number
  memberQuantity: number
  publicQuantity: number
  memberPriceCents: number
  publicPriceCents: number
  lineTotalCents: number
}

export interface ShopQuote {
  items: QuoteItem[]
  totalCents: number
  currency: 'EUR'
  fingerprint: string
}

export interface OrderItem {
  id: number
  productId: number
  variantId: number
  productName: string
  variantLabel: string
  imageUrl: string
  quantity: number
  memberQuantity: number
  memberUnitPriceCents: number
  publicUnitPriceCents: number
  lineTotalCents: number
}

export interface ShopPayment {
  id: number
  method: PaymentMethod
  provider: 'MANUAL' | 'STRIPE'
  status: PaymentStatus
  amountCents: number
  currency: string
  paidAt: string | null
  refundedAt: string | null
}

export interface ShopOrder {
  id: number
  orderNumber: string
  userId: number | null
  guestBuyerId: number | null
  firstName: string
  lastName: string
  email: string
  status: OrderStatus
  totalCents: number
  currency: string
  createdAt: string
  updatedAt: string
  completedAt: string | null
  cancelledAt: string | null
  items: OrderItem[]
  payment: ShopPayment | null
}

export const formatPrice = (cents: number) => new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
}).format(cents / 100)

export const orderStatusLabels: Record<OrderStatus, string> = {
  PENDING: 'En attente',
  CONFIRMED: 'Confirmée',
  READY_FOR_PICKUP: 'Prête au retrait',
  COMPLETED: 'Remise',
  CANCELLED: 'Annulée',
}

export const paymentStatusLabels: Record<PaymentStatus, string> = {
  PENDING: 'À payer',
  PAID: 'Payée',
  REFUNDED: 'Remboursée',
  FAILED: 'Échec',
}

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  CASH: 'Espèces',
  CHECK: 'Chèque',
  BANK_TRANSFER: 'Virement',
  CARD: 'Carte',
}
